const regex = new RegExp(/(^https?:\/\/)((www.)?scmp.com|.*.product-web.dev-2.scmp.tech)/);
export const checkIsInternalScmpLink = (href: string) => regex.test(href);
